import { Pipe, PipeTransform } from '@angular/core';
/*
 * Truncates an text with defined cut off length
 * Takes an input parameter string.
 * Usage:
 *   string | truncatetext: 100
 * Example:
 *   <p>{{ string | truncatetext: 100 }}></p>
*/
@Pipe({
  name: 'truncatetext'
})
export class TruncateTextNewPipe implements PipeTransform {
  transform(value: string, length: number, withQuote: number): string {
    const biggestWord = 50;
    const elipses = '…';

    if (typeof value === 'undefined') { return value; }
    if ((value === null) || (value === '')) {
      value = '';
    } else {
      //value = value.replace(/<(?:.|\n)*?>/gm, ' ');
      var tmp = document.createElement("DIV");
      tmp.innerHTML = value;
      value = tmp.textContent || tmp.innerText || "";
    }
    if (value.length <= length) { return value; }



    //.. truncate to about correct lenght
    let truncatedText = value.slice(0, length + biggestWord);
    //.. now nibble ends till correct length
    while (truncatedText.length > length - elipses.length) {
      let lastSpace = truncatedText.lastIndexOf(" ");
      if (lastSpace === -1) break;
      truncatedText = truncatedText.slice(0, lastSpace).replace(/[!,.?;:]$/, '');
    }
    let result = truncatedText + elipses;
    return (withQuote == 0) ? result : '"' + result + '"';
  }
}
